import { action } from '@ember/object';
import { bannerError } from 'client-portal/utils/error-handling';
import { reads } from '@ember/object/computed';
import { service } from '@ember/service';
import Controller from '@ember/controller';
import classic from 'ember-classic-decorator';

@classic
export default class SiteLegalAgreementsController extends Controller {
  @service intl;
  @service router;
  @service session;
  @service store;

  @reads('session.currentClientAccess.eulaAgreementAccepted') hasAcceptedEula;

  @action
  async acceptLegalAgreements(agreements) {
    try {
      let adapter = this.store.adapterFor('client-access');
      let agreementsAccepted = JSON.stringify(agreements.mapBy('id'));
      let data = {
        data: { type: 'legal-agreements', attributes: { agreementsAccepted } },
      };

      await adapter.acceptLegalAgreements(data);

      this.send('refreshEnvironment');
      this.router.transitionTo('site.home');
    } catch (err) {
      bannerError(err, { title: this.intl.t('messages.error.legalAgreementsNotAccepted') });
    }
  }
}
